export enum DividerSlug {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}
